import React from 'react'

const Cp_rot = () => {
    return (
        <div className='container'>
            <h1>Rotate a Matrix Anticlockwise in C++</h1>
            <p>A given N x N matrix will have (N/2) square cycles. Like a 3 X 3 matrix will have 1 cycle. The cycle is formed by its first row, last column, last row, and first column. <br />
For each square cycle, we are going to swap the elements involved with the corresponding cell in the matrix in the anticlockwise direction in this case. We will just need a temporary variable for keeping that array element.</p>

<p><strong>Example:</strong></p> 
<div className='output'>
<p><strong>Input:</strong> </p><br />
<br />
1 2 3<br />
<br />
4 5 6<br />
<br />
7 8 9<br />
Output:<br />
<br />
3 6 9<br />
<br />
2 5 8<br />
<br />
1 4 7<br />
</div>
<div class="containers" >
  <div >
    <div><span class="comment">// Rotating matrix by 90 degree in Anticlockwise direction in C++</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"></span><span class="enlighter-k4">#include&lt;bits/stdc++.h&gt;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"></span><span class="library">using</span><span class="plain">
      </span><span class="library">namespace</span><span class="plain"> std;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"></span><span class="keywords">int</span><span class="plain">
      </span><span class="=keywords">main</span><span class="keywords">()</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">int </span><span class="plain">
        n;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cout</span><span class="enlighter-g1">&lt;&lt;</span><span
        class="plain">"Enter size of matrix (NxN): "</span><span class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cin</span><span class="enlighter-g1">&gt;&gt;</span><span
        class="plain">n;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">int</span><span class="plain">
        arr</span><span class="enlighter-g1">[</span><span class="plain">n</span><span
        class="enlighter-g1">][</span><span class="plain">n</span><span class="enlighter-g1">]</span><span
        class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cout</span><span class="enlighter-g1">&lt;&lt;</span><span
        class="plain">"\nEnter matrix elements:\n"</span><span class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        i=0;i</span><span class="enlighter-g1">&lt;</span><span class="plain">n;i++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        j=0;j</span><span class="enlighter-g1">&lt;</span><span class="plain">n;j++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cin</span><span class="enlighter-g1">&gt;&gt;</span><span
        class="plain">arr</span><span class="enlighter-g1">[</span><span class="plain">i</span><span
        class="enlighter-g1">][</span><span class="plain">j</span><span class="enlighter-g1">]</span><span
        class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        i=0;i</span><span class="enlighter-g1">&lt;</span><span class="plain">n/2;i++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        j=i;j</span><span class="enlighter-g1">&lt;</span><span class="plain">n-i-1;j++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="comment"> // Swapping elements after each iteration in
        Anticlockwise direction</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">int</span><span class="plain">
        temp=arr</span><span class="enlighter-g1">[</span><span class="plain">i</span><span
        class="enlighter-g1">][</span><span class="plain">j</span><span class="enlighter-g1">]</span><span
        class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> arr</span><span class="enlighter-g1">[</span><span
        class="plain">i</span><span class="enlighter-g1">][</span><span class="plain">j</span><span
        class="enlighter-g1">]</span><span class="plain">=arr</span><span class="enlighter-g1">[</span><span
        class="plain">j</span><span class="enlighter-g1">][</span><span
        class="plain">n-i-1</span><span class="enlighter-g1">]</span><span class="plain">;</span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> arr</span><span class="enlighter-g1">[</span><span
        class="plain">j</span><span class="enlighter-g1">][</span><span
        class="plain">n-i-1</span><span class="enlighter-g1">]</span><span
        class="plain">=arr</span><span class="enlighter-g1">[</span><span
        class="plain">n-i-1</span><span class="enlighter-g1">][</span><span
        class="plain">n-j-1</span><span class="enlighter-g1">]</span><span class="plain">;</span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> arr</span><span class="enlighter-g1">[</span><span
        class="plain">n-i-1</span><span class="enlighter-g1">][</span><span
        class="plain">n-j-1</span><span class="enlighter-g1">]</span><span
        class="plain">=arr</span><span class="enlighter-g1">[</span><span
        class="plain">n-j-1</span><span class="enlighter-g1">][</span><span
        class="plain">i</span><span class="enlighter-g1">]</span><span class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> arr</span><span class="enlighter-g1">[</span><span
        class="plain">n-j-1</span><span class="enlighter-g1">][</span><span
        class="plain">i</span><span class="enlighter-g1">]</span><span class="plain">=temp;</span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div></div> <br/>
  </div> <br/>
  <div >
    <div><span class="comment"> // Printing matrix elements after
        rotation</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cout</span><span class="enlighter-g1">&lt;&lt;</span><span
        class="plain">"\nMatrix after rotating 90 degree anticlockwise:\n"</span><span
        class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        i=0;i</span><span class="enlighter-g1">&lt;</span><span class="plain">n;i++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="keywords">for</span><span
        class="enlighter-g1">(</span><span class="keywords">int</span><span class="plain">
        j=0;j</span><span class="enlighter-g1">&lt;</span><span class="plain">n;j++</span><span
        class="enlighter-g1">)</span><span class="plain"></span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#123;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cout</span><span class="enlighter-g1">&lt;&lt;</span><span
        class="plain">arr</span><span class="enlighter-g1">[</span><span class="plain">i</span><span
        class="enlighter-g1">][</span><span class="plain">j</span><span
        class="enlighter-g1">]&lt;&lt;</span><span class="plain">" "</span><span class="plain">;</span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"> cout</span><span class="enlighter-g1">&lt;&lt;</span><span
        class="plain">"\n"</span><span class="plain">;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="enlighter-g1">&#125;</span><span class="plain"></span>
    </div> <br/>
  </div> <br/>
  <div >
    <div><span class="library">return</span><span class="plain">
        0;</span></div> <br/>
  </div> <br/>
  <div >
    <div><span class="plain"></span><span class="enlighter-g1">&#125;</span></div> <br/>
  </div> <br/>
</div> 

        </div>
    )
}

export default Cp_rot
